import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjectTask } from '../objects/Project'; // Import your data model
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectTaskService {
  private apiUrl = environment.apiUrl +'ProjectTasks'; // Replace with your API endpoint

  constructor(private http: HttpClient) { }

  getProjectTasks(): Observable<ProjectTask[]> {
    return this.http.get<ProjectTask[]>(this.apiUrl);
  }

  

  getProjectTask(id: number): Observable<ProjectTask> {
    return this.http.get<ProjectTask>(`${this.apiUrl}/${id}`);
  }

  addProjectTask(ProjectTask: ProjectTask): Observable<ProjectTask> {
    return this.http.post<ProjectTask>(this.apiUrl, ProjectTask);
  }
  deleteProjectTask(ProjectTask: ProjectTask): Observable<ProjectTask> {
    const url = `${this.apiUrl}/${ProjectTask.id}`;
    return this.http.delete<ProjectTask>(url);
  }
  updateProjectTask(ProjectTask: ProjectTask): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${ProjectTask.id}`, ProjectTask,
    {
      headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      }
    );
    }
  // updateProjectTask(ProjectTask: ProjectTask): Observable<void> {
  //   return this.http.put<void>(`${this.apiUrl}/${ProjectTask.id}`, ProjectTask);

    
  // }
  
  // GET: api/ProjectTasks/ByProject/5
  getProjectTasksByProjectID(projectId: number): Observable<ProjectTask[]> {
    return this.http.get<ProjectTask[]>(`${this.apiUrl}/ByProject/${projectId}`);
  }
  
  // Other CRUD methods
}
